<template>
  <transition name="a-transtion-slide">
    <div class="m-the-header-upgrade">
      <p>
        {{ $t('mTheHeaderLicenseUpgrade.upgrade.firstText') }}
        <router-link
          :to="`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}/${this.$t('mEditionMenu.billing.myPayments.children.changePlan.subedition')}`"
          class="text-link-hover-academy"
        >
          <i class="far fa-link font-size-small"></i>
          {{ $t('mTheHeaderLicenseUpgrade.upgrade.linkText') }}
        </router-link>
        <a
          class="close-header-message"
          href="#"
          @click.prevent="hideLicenseUpgradeMessage()"
        >
          <i class="fas fa-times"></i>
        </a>
      </p>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'MoleculeTheHeaderLicenseUpgrade',

  methods: {
    hideLicenseUpgradeMessage () {
      this.$store.commit('setAcademyShowHeaderMessage', false)
    }
  }
}
</script>
